/**
 * Reusable CSV export utility for all pages.
 * Usage: downloadCSV(rows, filename)
 * rows: Array of objects (each object = one row)
 * filename: string (e.g. 'employees_export.csv')
 */
export function downloadCSV(rows, filename = 'export.csv') {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const csvContent = [
    headers.join(','),
    ...rows.map(row =>
      headers.map(h => {
        let val = row[h] ?? '';
        if (typeof val === 'string' && (val.includes(',') || val.includes('"') || val.includes('\n'))) {
          val = `"${val.replace(/"/g, '""')}"`;
        }
        return val;
      }).join(',')
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Download a blob response from an API as a file.
 */
export async function downloadBlobFromAPI(axios, url, filename, params = {}) {
  const response = await axios.get(url, {
    params,
    withCredentials: true,
    responseType: 'blob',
  });
  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}

/**
 * Format permission duration in minutes to human-readable hours and minutes.
 * Examples: 60 -> "1 hour", 110 -> "1 hour 50 minutes", 30 -> "30 minutes", 120 -> "2 hours"
 */
export function formatPermissionDuration(minutes) {
  if (minutes === null || minutes === undefined || isNaN(minutes) || Number(minutes) <= 0) {
    return '0 minutes';
  }
  const totalMins = Math.round(Number(minutes));
  const hrs = Math.floor(totalMins / 60);
  const remMins = totalMins % 60;
  if (hrs > 0 && remMins > 0) {
    return `${hrs} hour${hrs > 1 ? 's' : ''} ${remMins} minute${remMins > 1 ? 's' : ''}`;
  } else if (hrs > 0) {
    return `${hrs} hour${hrs > 1 ? 's' : ''}`;
  } else {
    return `${remMins} minute${remMins > 1 ? 's' : ''}`;
  }
}
